import React, {useState, useEffect, useContext, useRef} from 'react'
import {
  Button,
  Grid,
  Box,
  TextField,
  MenuItem,
  InputAdornment,
  IconButton,
  CircularProgress,
} from '@material-ui/core'
import ReorderIcon from '@material-ui/icons/Reorder'
import ViewAgendaIcon from '@material-ui/icons/ViewAgenda'
import SearchIcon from '@material-ui/icons/Search'
import FilterListIcon from '@material-ui/icons/FilterList'
import {Query} from 'react-apollo'
import {listingFields} from '../../graphql/barcode/queries/listingFieldsQuery'
import {ToggleButtonGroup, ToggleButton} from '@material-ui/lab'
import LoadingScreen from '../BarcodeLoadingScreen'
import FieldValueTable from './BarcodeFieldValueTable'
import FieldFilterSearch from './BarcodeFieldFilterSearch'
import FieldValueDrawer from './BarcodeFieldDrawer'
import {useTranslation} from 'react-i18next'
import {Mutation} from 'react-apollo'
import {sendFieldValueRequest} from '../../graphql/barcode/mutations/sendFieldValueMutation'
import useStyles from './BarcodeWizardGenerateFieldValue.styles'
import {BarcodeUserSettingsContext} from '../../context/BarcodeUserSettings'
import {ToastMessageContext} from '../../context/ToastMessage'
import {UserContext} from '../../context/UserContext'
import {validateBarcodePermission} from '../../modules/common/utils/permissions'

export default function BarcodeWizardGenerateFieldValue(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const [density, setDensity] = useState('expand')
  const {userSettings} = useContext(BarcodeUserSettingsContext)
  const [formValues, setFormValues] = useState({
    search: '',
    match: 'partial',
    entity: 'all',
  })
  const [displayFields, setDisplayFields] = useState([])
  const [searchFields, setSearchFields] = useState([])
  const [disableMatch, setDisabledMatch] = useState(true)
  const [hideFilters, setHideFilters] = useState(true)
  const [filterValues, setFilterValues] = useState('')
  const [fieldMatch, setFieldMatch] = useState('')
  const [search, setSearch] = useState('')
  const [itemsSelected, setItemsSelected] = useState([])
  const [totalFilter, setTotalFilter] = useState(0)
  const [fieldFilters, setFieldFilters] = useState('')
  const [barcodeSettingRecord] = React.useState(
    props.location.state ? props.location.state.barcodeData : {}
  )
  const userId = parseInt(window.localStorage.getItem('user_id'))
  const userEmail = window.localStorage.getItem('user_email')
  const [pageOffset, setPageOffset] = useState(0)
  const [loadedObjects, setLoadedObjects] = useState([])
  const [openDrawer, setOpenDrawer] = useState(false)
  const [startPosition, setStartPosition] = useState(1)
  const toast = useContext(ToastMessageContext)
  const currentUser = React.useContext(UserContext)
  const refBtnGenerate = useRef(null)
  const {history} = props

  useEffect(() => {
    if (!!!props.location.state) {
      history.replace({
        pathname: 'barcode_generator',
      })
    }
  }, [props.location.state, history])

  useEffect(() => {
    if (window !== window.parent) {
      window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
    } else {
      window.scrollTo(0, 0)
    }
  }, [])

  const handleDensity = (event, newDensity) => {
    if (newDensity) {
      setDensity(newDensity)
    }
  }

  function resetButtonClick(event, filters) {
    if (filters) {
      setFieldFilters('')
    } else {
      setFormValues({
        search: '',
        match: 'partial',
        entity: 'all',
      })
      setDisabledMatch(true)
      setSearch('')
      setFilterValues('')
      setFieldMatch('')
    }
    setItemsSelected([])
    setLoadedObjects([])
    setPageOffset(0)
  }

  function filterButtonClick(event) {
    if (hideFilters) {
      setHideFilters(false)
    } else {
      setHideFilters(true)
    }
  }

  function filterValuesClick(event, filters) {
    if (formValues.entity === 'all') {
      setSearch(formValues.search)
    } else {
      setFilterValues({[formValues.entity]: formValues.search})
    }
    if (filters === {} || filters === undefined || filters === null) {
      setFieldFilters('')
    } else {
      let records = {}
      Object.keys(filters).map(data => {
        return (records[filters[data].field_key] = filters[data].value)
      })
      setFieldFilters(records)
    }
    setPageOffset(0)
    setLoadedObjects([])
    setFieldMatch(formValues.match)
    setItemsSelected([])
  }

  const handleChange = textField => event => {
    if (textField === 'entity' && event.target.value !== 'all') {
      setDisabledMatch(false)
      setFormValues({
        ...formValues,
        [textField]: event.target.value,
      })
    }
    if (textField === 'entity' && event.target.value === 'all') {
      setDisabledMatch(true)
      setFormValues({
        ...formValues,
        [textField]: event.target.value,
        match: 'partial',
      })
    } else {
      setFormValues({
        ...formValues,
        [textField]: event.target.value,
      })
    }
  }

  const clickPreview = event => {
    window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
    setOpenDrawer(true)
  }

  function generateMultipleFieldValue(sendFieldValueRequest, event) {
    if(!validateBarcodePermission(currentUser, "can_generate")){
      return;
    }
    if (itemsSelected.length === 0) {
      toast.popMessage(t('barcode.wizard.generate-field.select-record'), 'warning', event.target)
      return
    }

    let ids = []
    itemsSelected.map(record => {
      return ids.push(record.id)
    })

    sendFieldValueRequest({
      variables: {
        startingPositionOnSheet: parseInt(startPosition),
        ids: ids,
        barcodeSettingId: parseInt(barcodeSettingRecord.id),
        token: userSettings.token,
        userId: userId,
        userEmail: userEmail,
      },
    })
  }

  function checkReturnData(data) {
    if (
      data.sendFieldValueRequest.errors.length === 1 &&
      data.sendFieldValueRequest.pdfData.location.length > 0
    ) {
      window.location.href = `${data.sendFieldValueRequest.pdfData.location}`
    } else {
      toast.popMessage(data.sendFieldValueRequest.errors[0], 'error', refBtnGenerate.current)
    }
  }

  return (
    <div>
      <Query
        query={listingFields}
        variables={{
          entityId: parseInt(barcodeSettingRecord.entityId),
          token: userSettings.token,
        }}
      >
        {({loading, error, data}) => {
          if (loading) {
            return (
              <div style={{marginTop: 35}}>
                <LoadingScreen size={50} />
              </div>
            )
          }
          if (error) {
            return (
              <div>
                {props.history.push({
                  pathname: 'pageNotFound',
                })}
              </div>
            )
          }

          setSearchFields(data.listingFields.searchFields)
          setDisplayFields(data.listingFields.displayFields)

          return (
            <div>
              <Grid container item xs={12}>
                <Grid container item xs={6} justify="flex-start">
                  <Box className={classes.startPosition}>
                    {t('barcode.wizard.value-drawer.start-position') + startPosition}
                  </Box>
                </Grid>
                <Grid container item xs={6} justify="flex-end">
                  <Button
                    onClick={clickPreview}
                    value="preview"
                    variant="outlined"
                    className={classes.btnGeneratePreview}
                    color="primary"
                  >
                    {t('barcode.wizard.generate-field.preview')}
                  </Button>

                  <Mutation
                    mutation={sendFieldValueRequest}
                    onCompleted={data => checkReturnData(data)}
                  >
                    {(sendFieldValueRequest, {loading, data}) => {
                      return (
                        <Button
                          ref={refBtnGenerate}
                          onClick={e => generateMultipleFieldValue(sendFieldValueRequest, e)}
                          value="generate"
                          variant="contained"
                          color="primary"
                          className={classes.btnGeneratePreview}
                        >
                          {loading ? (
                            <div>
                              {t('barcode.wizard.value-drawer.generating')}
                              <CircularProgress size={20} color="secondary" />
                            </div>
                          ) : (
                            t('barcode.wizard.value-drawer.generate')
                          )}
                        </Button>
                      )
                    }}
                  </Mutation>
                </Grid>
              </Grid>
              <Grid container item xs={12} className={classes.gridMargin} spacing={1}>
                <Grid container item xs={3}>
                  <TextField
                    id="outlined-name"
                    label={t('barcode.wizard.generate-field.search')}
                    value={formValues.search}
                    fullWidth
                    variant="outlined"
                    onChange={handleChange('search')}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment>
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid container item xs={6} className={classes.searchSection}>
                  <TextField
                    id="outlined-select-output"
                    select
                    label={t('barcode.wizard.generate-field.search-all')}
                    value={formValues.entity}
                    style={{width: 180}}
                    onChange={handleChange('entity')}
                    SelectProps={{
                      MenuProps: {
                        getContentAnchorEl: null,
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                      },
                    }}
                    variant="outlined"
                  >
                    <MenuItem key="all" value="all">
                      {t('barcode.wizard.generate-field.search-all')}
                    </MenuItem>
                    {searchFields.map(data => (
                      <MenuItem key={data.key} value={data.key}>
                        {data.name}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Box marginLeft={2} />
                  <TextField
                    id="outlined-select-output"
                    select
                    label={t('barcode.wizard.generate-field.search-all')}
                    value={formValues.match}
                    style={{width: 180}}
                    onChange={handleChange('match')}
                    SelectProps={{
                      MenuProps: {
                        getContentAnchorEl: null,
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                      },
                    }}
                    variant="outlined"
                    disabled={disableMatch}
                  >
                    {[
                      ['Partial Match', 'partial'],
                      ['Full Match', 'full'],
                    ].map(data => (
                      <MenuItem key={data[1]} value={data[1]}>
                        {data[0]}
                      </MenuItem>
                    ))}
                  </TextField>

                  <Button
                    value="apply"
                    variant="contained"
                    className={classes.buttonLink}
                    color="primary"
                    onClick={filterValuesClick}
                  >
                    {t('barcode.wizard.generate-field.apply')}
                  </Button>

                  <Button
                    value="reset"
                    variant="outlined"
                    className={classes.buttonLink}
                    color="primary"
                    onClick={resetButtonClick}
                  >
                    {t('barcode.wizard.generate-field.reset')}
                  </Button>
                </Grid>

                <Grid
                  container
                  item
                  xs={3}
                  justify="flex-end"
                  alignItems="center"
                  className={classes.searchSection}
                >
                  <Box fontSize={15} fontWeight={400}>
                    {t('barcode.wizard.generate-field.display-density')}
                    <ToggleButtonGroup
                      value={density}
                      exclusive
                      onChange={handleDensity}
                      className={classes.toggleButtonMargin}
                      size="small"
                    >
                      <ToggleButton value="expand">
                        <ViewAgendaIcon color={density === 'expand' ? 'primary' : 'inherit'} />
                      </ToggleButton>
                      <ToggleButton value="compress">
                        <ReorderIcon color={density === 'compress' ? 'primary' : 'inherit'} />
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Grid>
              </Grid>

              <Grid container className={classes.gridMargin}>
                <Grid container item xs={12} justify="flex-start">
                  <Box fontSize={15} fontWeight={400}>
                    {t('barcode.wizard.generate-field.filter-result')}
                    <IconButton onClick={filterButtonClick}>
                      <FilterListIcon />
                    </IconButton>
                    <span className={classes.totalFilter}>
                      {totalFilter > 0 ? totalFilter + ' Filter(s) Selected' : ''}
                    </span>
                  </Box>
                </Grid>
              </Grid>

              <FieldFilterSearch
                hideFilters={hideFilters}
                token={userSettings.token}
                entityId={barcodeSettingRecord.entityId}
                setTotalFilter={setTotalFilter}
                filterValuesClick={filterValuesClick}
                resetButtonClick={resetButtonClick}
              />

              <div className={classes.gridMargin}>
                {displayFields !== [] && (
                  <FieldValueTable
                    dense={density}
                    displayFields={displayFields}
                    entityId={barcodeSettingRecord.entityId}
                    token={userSettings.token}
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                    fieldMatch={fieldMatch}
                    search={search}
                    selected={itemsSelected}
                    setSelected={setItemsSelected}
                    fieldFilters={fieldFilters}
                    setFieldMatch={setFieldMatch}
                    setPageOffset={setPageOffset}
                    pageOffset={pageOffset}
                    setLoadedObjects={setLoadedObjects}
                    loadedObjects={loadedObjects}
                  />
                )}
              </div>
            </div>
          )
        }}
      </Query>
      <Grid container item xs={12}>
        <Grid container item xs={6} justify="flex-start">
          <Box className={classes.startPosition}>
            {t('barcode.wizard.value-drawer.start-position') + startPosition}
          </Box>
        </Grid>
        <Grid container item xs={6} justify="flex-end">
          <Button
            onClick={clickPreview}
            value="preview"
            variant="outlined"
            className={classes.btnGeneratePreview}
            color="primary"
          >
            {t('barcode.wizard.generate-field.preview')}
          </Button>

          <Mutation mutation={sendFieldValueRequest} onCompleted={data => checkReturnData(data)}>
            {(sendFieldValueRequest, {loading, data}) => {
              return (
                <Button
                  ref={refBtnGenerate}
                  onClick={e => generateMultipleFieldValue(sendFieldValueRequest, e)}
                  value="generate"
                  variant="contained"
                  color="primary"
                  disabled = {!validateBarcodePermission(currentUser, "can_generate")}
                  className={classes.btnGeneratePreview}
                >
                  {loading ? (
                    <div>
                      {t('barcode.wizard.value-drawer.generating')}
                      <CircularProgress size={20} color="secondary" />
                    </div>
                  ) : (
                    t('barcode.wizard.value-drawer.generate')
                  )}
                </Button>
              )
            }}
          </Mutation>
        </Grid>
      </Grid>

      <FieldValueDrawer
        barcodeSettingId={barcodeSettingRecord.id}
        itemsSelected={itemsSelected}
        setItemsSelected={setItemsSelected}
        displayFields={displayFields}
        token={userSettings.token}
        userId={userId}
        userEmail={userEmail}
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
        setStartPosition={setStartPosition}
      />
    </div>
  )
}
